import luxy from "luxy.js";

/*
 *
 * ----------------------------------------------- */
jQuery(window).on("load", function () {
  if ($("#luxy").length) {
    luxy.init();
  }
});
